import axiosInstance from '@/api/apiClient'
import { PlayerResourceLimitsResponse } from '@/redux/types/resourceLimits'
import { getErrorMessage } from '@/lib/utils'

export const getPlayerResourceLimits = async (
  roomId: string
): Promise<PlayerResourceLimitsResponse> => {
  try {
    const response = await axiosInstance.get(
      `/oge/rooms/${roomId}/player-resource-limits/`
    )
    return response.data
  } catch (error) {
    throw new Error(getErrorMessage(error))
  }
}

export const updatePlayerResourceLimits = async (
  roomId: string,
  updates: Array<{
    player_id: number
    message_limit?: number | null
    token_limit?: number | null
    currency_limit?: number | null
  }>
) => {
  try {
    const response = await axiosInstance.patch(
      `/oge/rooms/${roomId}/player-resource-limits/`,
      { updates }
    )
    return response.data
  } catch (error) {
    throw new Error(getErrorMessage(error))
  }
}
